import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const SLACK_CONFIGURATIONS_QUERY_KEY = 'slack-configurations';

export const getSlackConfigurationsQueryKey = (orgId?: string) =>
  [
    SLACK_CONFIGURATIONS_QUERY_KEY,
    ...(orgId !== undefined ? [orgId] : []),
  ] as const;

const getSlackConfigurationsQueryOptions = ({
  orgId,
  enabled,
}: {
  orgId: string | undefined;
  enabled: boolean;
}) =>
  queryOptions({
    queryKey: getSlackConfigurationsQueryKey(orgId),
    queryFn: async () => {
      const { data } = await apiClient.notifications.listSlackConfigurations();
      return data;
    },
    enabled,
  });

export const useGetSlackConfigurations = (enabled: boolean) => {
  const { currentOrganization } = useOrganizations();
  const { data, error, isLoading } = useQuery(
    getSlackConfigurationsQueryOptions({
      orgId: currentOrganization?.id,
      enabled,
    })
  );

  return { data, error, isLoading };
};
